module.exports = __webpack_public_path__ + "img/certified.f83fc662.png";